module.exports = __webpack_public_path__ + "img/yellow-carats.9a3d9e6a.svg";